import React, { Component, useContext } from 'react';
import Swal from 'sweetalert2';
import TextField from '@material-ui/core/TextField';
import { DayPilot, DayPilotScheduler } from 'daypilot-pro-react';
import axios from 'axios';
import MuiAlert from '@material-ui/lab/Alert';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';
import Snackbar from '@material-ui/core/Snackbar';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import Grid from '@material-ui/core/Grid';
import makeStyles from '@material-ui/core/styles/makeStyles';
import moment from 'moment';
import SettingsIcon from '@material-ui/icons/Settings';
import ResDetais from './ResDetails.js';
import { connect, useSelector } from 'react-redux';
import AppContext from '../../../@jumbo/components/contextProvider/AppContextProvider/AppContext';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Box, LinearProgress } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import { Add, MyLocation, NavigateBefore, NavigateNext } from '@material-ui/icons';
import { getMyDate, getMyDate2, myFormatDate2 } from '../../../@jumbo/utils/commonHelper';
import { KeyboardDatePicker } from '@material-ui/pickers';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import SelectFolio from '../invoices/SelectFolio';
import SetRoomStatus from './SetRoomStatus';
import SettingsForm2 from './SettingsForm2';

require('./App.css');

const breadcrumbs = [
  //  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  //  { label: <IntlMessages id={'pages.calendarPage'} />, isActive: true },
];
const useStyles = theme => ({
  input1: {
    height: 2,
    fontSize: '1em',
  },
  hotelSelect: {
    width: '100%',
    marginBottom: theme.spacing(1),
  },

  viewModeSelect: {
    paddingLeft: theme.spacing(2),
  },
  boxClass2: {
    display: 'flex',
    justifyContent: 'normal',
    alignItems: 'center',
    '& > *': {
      marginBottom: theme.spacing(1),
    },
  },
  boxClass: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.up('md')]: {
      maxWidth: '500px',
    },
    '& > *': {
      marginBottom: theme.spacing(1),
    },
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class TimeLine extends Component {
  constructor(props) {
    super(props);
    //    const [openRes, setOpenRes] = React.useState(false);
    var hotels = props.auth.authUser.hotels;
    var storedDate = localStorage.getItem('timelineDateStart');
    if (storedDate == null || storedDate == '' || storedDate == undefined || storedDate == 'Invalid date')
      storedDate = moment()
        .subtract(2, 'day')
        .format('YYYY-MM-DD');
    //getMyDate(moment());

    const startdate = storedDate;
    var hotels = this.props.auth.authUser.hotels;
    var myhotels = '';
    var hotels = this.props.auth.authUser.hotels;
    hotels.forEach(function(element, index) {
      var hid = element.id;
      if (myhotels != '') myhotels = myhotels + ',';
      myhotels = myhotels + hid;
    });

    var defaultLocale = 'en-en';
    //    if (this.props.auth.authUser.cloudUser == 1) defaultLocale = 'hr-hr';
    //  else {
    if (this.props.auth.authUser.language == 'hr') defaultLocale = 'hr-hr';
    if (this.props.auth.authUser.language == 'sr') defaultLocale = 'sr-rs';
    //}

    var lastViewMode = localStorage.getItem('lastViewMode');
    if (lastViewMode == null || lastViewMode == '' || lastViewMode == undefined) lastViewMode = 3;

    var showOcc = localStorage.getItem('showOcc');
    if (showOcc == null || showOcc == '' || showOcc == undefined) showOcc = 1;

    var lastHotelId = localStorage.getItem('lastHotelId');
    if (lastHotelId != myhotels)
      if (
        lastHotelId == null ||
        lastHotelId == '' ||
        lastHotelId == undefined ||
        this.props.auth.authUser.hotels.filter(({ id }) => id == lastHotelId).length == 0
      )
        lastHotelId = hotels[0].id;

    var cw = 20;
    if (lastViewMode == 0) cw = window.innerWidth / 20;
    if (lastViewMode == 1) cw = window.innerWidth / 40;
    if (lastViewMode == 2) cw = window.innerWidth / 60;
    if (lastViewMode == 3) cw = window.innerWidth / 80;
    if (lastViewMode == 4) cw = window.innerWidth / 95;
    if (cw < 20) cw = 20;

    this.state = {
      selectedRoomId: -1,
      selectedHotelId: -1,
      currentStatus: 'C',
      setStatusVisible: false,
      dynamicLoading: false,
      lastStart: '',
      lastEnd: '',
      // hotel_id: hotels[0].id,
      settingsForm: false,
      myhotels: myhotels,
      viewMode: lastViewMode,
      showOcc: showOcc,
      resources: [],
      fullResources: [],
      startDate: startdate,
      running2: false,
      lastEvents: [],
      hotelId: lastHotelId,
      checkData: [],
      eventHoverHandling: 'Bubble',
      showToolTip: true,
      rowHeaderColumns: [{ title: '', display: 'name' }],
      timeHeaders: [{ groupBy: 'Month' }, { groupBy: 'Day', format: 'd' }, { groupBy: 'Day', format: 'ddd' }],
      bubble: new DayPilot.Bubble({
        animated: false,
        animation: 'jump',
        onBeforeDomAdd: args => {
          const e = args.source;
          args.html = e.data.bubbleHtml;
        },
      }),
      treeEnabled: true,
      days: 38,
      cellDuration: 720,
      errorConnection: false,
      cellWidth: cw,

      scale: 'CellDuration',
      selReservationId: '',
      selReservationHotelId: '',
      selResTitle: '',
      locale: defaultLocale,
      resDetailsVisible: false,
    };
    this.eventRowClick = this.eventRowClick.bind(this);
    this.canMove = this.canMove.bind(this);
    this.eventClick = this.eventClick.bind(this);
    this.eventMove = this.eventMove.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.handleCustomChange = this.handleCustomChange.bind(this);
    this.eventResize = this.eventResize.bind(this);
    this.eventMoving = this.eventMoving.bind(this);
    this.eventCreate = this.eventCreate.bind(this);
    this.doRefresh = this.doRefresh.bind(this);
    this.runAction = this.runAction.bind(this);
    this.loadResources = this.loadResources.bind(this);
  }

  doRefresh() {
    //    args.async = true;

    //    var start = args.viewport.start;
    //    var end = args.viewport.end;

    //    if (start != this.state.lastStart || end != this.state.lastEnd) {
    this.setState({ running2: true });
    const token = localStorage.getItem('token');
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    var myStart = getMyDate(this.state.lastStart);
    localStorage.setItem('timelineDateStart', getMyDate(this.state.lastStart));

    var senddata = {};
    if (this.props.auth.authUser.clouduser == 0) {
      var myhotelId = this.state.myhotels;
      if (this.props.auth.authUser.hotels.length > 1) myhotelId = this.state.hotelId;
      senddata = {
        Action: 'get_reservations',
        token: token,
        Version: 1,
        Data: {
          HotelId: myhotelId,
          From: this.state.lastStart,
          To: this.state.lastEnd,
          Occupancy: this.state.showOcc,
        },
      };
    } else {
      var hotelCodes = this.props.auth.authUser.hotels.filter(({ id }) => id == this.state.hotelId);
      var hotelCode = null;
      if (hotelCodes.length > 0) hotelCode = hotelCodes[0].hotelCode;
      senddata = {
        Action: 'get_reservations',
        token: token,
        Version: 1,
        Data: {
          HotelId: this.state.hotelId,
          HotelCode: hotelCode,
          PeriodStart: this.state.lastStart,
          PeriodEnd: this.state.lastEnd,
          SearchModel: 5,
        },
      };
    }

    console.log('url2: ' + pmsUrl);
    var self = this;
    axios.post(pmsUrl, senddata).then(res => {
      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
        localStorage.setItem('token', res.data.newToken);
      }
      //        this.setState({ lastStart: start });
      //        this.setState({ lastEnd: end });
      const data = res.data;
      if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();

      //            this.setState({ persons });
      var newevents = data.Data;
      if (data.Data != null && data.Data.Error != undefined) {
        this.setState({ errorConnection: true, running2: false });
      } else if (data.Data == null) {
        this.setState({ errorConnection: true, running2: false });
      } else {
        this.setState({ errorConnection: false });

        console.log(res);
        console.log(data);
        console.log(newevents);
        if (Array.isArray(newevents))
          newevents.forEach(function(item, index) {
            item['resource'] = item['RoomId'];
            item['start'] = item['Checkin'] + 'T12:00:00';
            item['end'] = item['Checkout'] + 'T12:00:00';
            if (self.props.auth.authUser.clouduser == 1) item['id'] = item['ReservationId'];
            else item['id'] = item['ReservationRoomId'];
            if (self.props.auth.authUser.clouduser == 1) item['fixed'] = 0;
            //else if (self.props.auth.authUser.clouduser == 1)
            item['bid'] = item['ReservationId'];
            item['bookingId'] = item['BookingId'];
            item['text'] = item['Text'];
            if (self.props.auth.authUser.clouduser == 0) item['hotelId'] = item['hotelId'];
            else item['hotelId'] = item['HotelId'];
            item['source'] = item['source'];
            item['backColor'] = item['Color'];
            //if (self.props.auth.authUser.clouduser == 0) item['bubbleHtml'] = item['bubbleHtml'];
            // if (item['TextColor']!=null) item['textColor'] = '#ffffff';
          });
        this.setState({ startDate: myStart, events: newevents, lastEvents: newevents });
        console.log('new events added');
        //this.scheduler.events = newevents;

        //        args.events = newevents;
        this.setState({ running2: false });
        try {
          //          args.loaded();
        } catch (e) {}
      }
    });
    //  } else {
    //      args.events = this.state.lastEvents;

    //    this.setState({ lastEvents: [], running2: false, lastStart: '' });
  }
  loadResources() {
    const token = localStorage.getItem('token');
    var myhotelId = this.state.myhotels;
    if (this.props.auth.authUser.clouduser == 0 && this.props.auth.authUser.hotels.length > 1)
      myhotelId = this.state.hotelId;

    const senddata = {
      Action: 'get_resources',
      token: token,
      Data: {
        HotelId: myhotelId,
        Cloud: this.props.auth.authUser.clouduser,
      },
    };

    //var pmsUrl = this.props.auth.authUser.pmsUrl;
    var resources = {};
    if (this.props.auth.authUser.clouduser == 0) {
      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      if (pmsUrl == '') return;
      this.setState({ running2: true });
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
        resources = res.data;
        if (resources.Data == null) {
          this.setState({ errorConnection: true });
        } else {
          this.setState({ resources: resources.Data });
          this.setState({ running2: false });
          this.setState({ errorConnection: false });
        }
      });
    } else {
      resources = [];

      var resources2 = this.props.auth.authUser.rooms;
      var resources3 = this.props.auth.authUser.hotels;
      if (this.state.hotelId == this.state.myhotels) {
        resources3.forEach((h, i2) => {
          var resources4 = [];
          var e2 = {};
          e2.id = 'hotel' + h.id;
          e2.name = h.name;
          e2.expanded = true;
          e2.children = [];
          resources2
            .filter(({ hotelid }) => {
              return hotelid == h.id;
            })
            .forEach((e, i) => {
              e.id = e.ID;
              e.name = e.Name;
              e2.children.push(e);
            });
          resources.push(e2);
        });
      } else
        resources2
          .filter(({ hotelid }) => {
            return hotelid == this.state.hotelId;
          })
          .forEach((e, i) => {
            e.id = e.ID;
            e.name = e.Name;
            resources.push(e);
          });
      console.log(resources);
      this.setState({ resources: resources });
    }

    if (this.props.auth.authUser.clouduser == 0) {
      const senddata = {
        Action: 'checkActions',
        token: token,
      };

      var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
      axios.post(pmsUrl, senddata).then(res => {
        if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
          localStorage.setItem('token', res.data.newToken);
        }
        if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
        this.setState({ checkData: res.data.Data });
      });
    }
  }

  componentDidMount() {
    const { currentPage, setCurrentPage } = this.context;
    const { intl } = this.props;
    if (this.props.auth.authUser.clouduser == 1) setCurrentPage(intl.formatMessage({ id: 'pages.timeline' }));
    //else setCurrentPage('BE');
    const { currentApplication, setCurrentApplication } = this.context;
    setCurrentApplication(1);

    DayPilot.Locale.register(
      new DayPilot.Locale('hr-hr', {
        dayNames: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota'],
        dayNamesShort: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
        monthNames: [
          'Siječanj',
          'Veljača',
          'Ožujak',
          'Travanj',
          'Svibanj',
          'Lipanj',
          'Srpanj',
          'Kolovoz',
          'Rujan',
          'Listopad',
          'Studeni',
          'Prosinac',
          '',
        ],
        monthNamesShort: ['SIJ', 'VELJ', 'OŽU', 'TRA', 'SVI', 'LIP', 'SRP', 'KOL', 'RUJ', 'LIS', 'STU', 'PRO', ''],
        timePattern: 'HH:mm',
        datePattern: 'dd/MM/yyyy',
        dateTimePattern: 'dd/MM/yyyy HH:mm',
        timeFormat: 'Clock24Hours',
        weekStarts: 1,
      }),
    );
    DayPilot.Locale.register(
      new DayPilot.Locale('sr-rs', {
        dayNames: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
        dayNamesShort: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
        monthNames: [
          'Januar',
          'Februar',
          'Mart',
          'April',
          'Maj',
          'Jun',
          'Jul',
          'Avgust',
          'Septembar',
          'Oktobar',
          'Novembar',
          'Decembar',
          '',
        ],
        monthNamesShort: ['JAN', 'FEB', 'MAR', 'API', 'MAJ', 'JUN', 'JUL', 'AVG', 'SEP', 'OKT', 'NOV', 'DEC', ''],
        timePattern: 'HH:mm',
        datePattern: 'dd/MM/yyyy',
        dateTimePattern: 'dd/MM/yyyy HH:mm',
        timeFormat: 'Clock24Hours',
        weekStarts: 1,
      }),
    );

    var self = this;

    var rs1 = intl.formatMessage({ id: 'timeline.viewReservation' });
    var rs2 = intl.formatMessage({ id: 'bookings.cancelReservation' });
    var rs3 = intl.formatMessage({ id: 'bookings.confirmCancel' });

    /*if (this.props.auth.authUser.clouduser == 1) {
      var menu1 = new DayPilot.Menu({
        items: [
          {
            text: rs1,
            onClick: function(args) {
              //            console.log(self.state.lastEvents);
              var x = self.state.lastEvents.find(({ id }) => id === args.source.id());
              //          console.log(x.bid);
              self.setState({ selResTitle: x.bookingId });
              self.setState({ selReservationId: x.bid });
              self.setState({ resDetailsVisible: true });
            },
          },
        ],
      });
    }
    if (this.props.auth.authUser.clouduser == 0)*/ {
      var menu1 = new DayPilot.Menu({
        items: [
          {
            text: rs1,
            onClick: function(args) {
              //            console.log(self.state.lastEvents);
              var x = self.state.lastEvents.find(({ id }) => id === args.source.id());
              //          console.log(x.bid);
              self.setState({
                selResTitle: x.bookingId,
                selReservationId: x.bid,
                selReservationHotelId: x.hotelId,
                resDetailsVisible: true,
              });
            },
          },
          {
            text: rs2,
            onClick: function(args) {
              var pmsUrl = this.props.auth.authUser.pmsUrl;
              if (pmsUrl == '') return;

              //var x = self.state.lastEvents.find(({ id }) => id === args.source.id());
              const token = localStorage.getItem('token');

              if (this.props.auth.authUser.clouduser == 1) {
                const senddata2 = {
                  Action: 'validate_action',
                  token: token,

                  Data: {
                    HotelId: self.state.myhotels,
                    ReservationId: args.source.id(),
                    Action: 'cancel_reservation',
                    User: this.props.auth.authUser.name,
                  },
                };
                axios.post(pmsUrl, senddata2).then(res => {
                  if (res.data != null && res.data.Result != null) {
                    //self.setState({ lastEvents: [], running2: false });
                    if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
                    if (res.data.Result == true) {
                      //var r = window.confirm(res.data.Message);
                      //if (r == true) {
                      Swal.fire({
                        title: rs2,
                        text: res.data.Message,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: intl.formatMessage({ id: 'yes' }),
                        cancelButtonText: intl.formatMessage({ id: 'no' }),
                      }).then(result => {
                        if (result.isConfirmed) {
                          const senddata = {
                            Action: 'cancel_reservation',
                            token: token,

                            Data: {
                              HotelId: self.state.myhotels,
                              ReservationId: args.source.id(),
                              User: this.props.auth.authUser.name,
                            },
                          };

                          //var pmsUrl = this.props.auth.authUser.pmsUrl;
                          //var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
                          self.setState({ running2: true });
                          axios.post(pmsUrl, senddata).then(res => {
                            if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                              localStorage.setItem('token', res.data.newToken);
                            }
                            if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false')
                              window.location.reload();
                            //self.setState({ lastEvents: [], running2: false });
                            this.doRefresh();
                          });
                        } else this.doRefresh();
                      });
                    } else {
                      Swal.fire({
                        title: intl.formatMessage({ id: 'error' }),
                        text: res.data.Message,
                        icon: 'error',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: intl.formatMessage({ id: 'ok' }),
                      }).then(result => {
                        //this.doRefresh();
                      });
                    }
                  }
                });
              } else {
                Swal.fire({
                  title: rs2,
                  text: rs3,
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonColor: '#3085d6',
                  cancelButtonColor: '#d33',
                  confirmButtonText: intl.formatMessage({ id: 'yes' }),
                  cancelButtonText: intl.formatMessage({ id: 'no' }),
                }).then(result => {
                  if (result.isConfirmed) {
                    //var r = window.confirm(rs3);
                    //if (r == true) {
                    const senddata = {
                      Action: 'cancel_reservation',
                      token: token,

                      Data: {
                        HotelId: self.state.myhotels,
                        ResId: args.source.id(),
                        User: this.props.auth.authUser.name,
                      },
                    };

                    //var pmsUrl = this.props.auth.authUser.pmsUrl;
                    //var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
                    self.setState({ running2: true });
                    axios.post(pmsUrl, senddata).then(res => {
                      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                        localStorage.setItem('token', res.data.newToken);
                      }
                      if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
                      //self.setState({ lastEvents: [], running2: false });
                      this.doRefresh();
                    });
                  }
                });
              }
            }.bind(this),
          },
        ],
      });
    }
    this.scheduler.contextMenu = menu1;

    this.loadResources();

    var storedDate = localStorage.getItem('timelineDateStart');
    if (storedDate == null || storedDate == '' || storedDate == undefined)
      storedDate = moment()
        .subtract(2, 'day')
        .format('YYYY-MM-DD');

    const today = storedDate;
    this.scheduler.scrollTo(today);
    console.log(this.state.viewMode);
    const today2 = moment(today)
      .add((parseInt(this.state.viewMode) + 1) * 7 + 3, 'day')
      .format('YYYY-MM-DD');
    console.log(today);
    console.log(today2);
    //this.scheduler.scrollTo(today);
    this.setState({ lastStart: today, lastEnd: today2, days: (parseInt(this.state.viewMode) + 1) * 7 + 3 }, () => {
      this.doRefresh();
    });
  }

  canMove(args) {
    //alert(JSON.stringify(args));
    var result = true;
    var x = args.e.resource();
    //console.log(x);
    if (typeof x == 'string') if (x.substring(0, 5) == 'group') result = false;
    return result;
  }

  eventCreate(args) {
    let dateFrom = getMyDate(args.start);
    let dateTo = getMyDate(args.end);
    if (dateFrom == dateTo) {
      var d1 = new Date(dateTo);
      //  today.setDate(today.getDate() + 3);
      var tomorrow = new Date();
      tomorrow.setDate(d1.getDate() + 1);
      dateTo = getMyDate(tomorrow);
    }

    let isgroup = 0,
      ishotel = 0,
      resource_id = 0,
      is_room_number = 0;
    if (args.resource.substring(0, 5) == 'group') isgroup = 1;
    if (args.resource.substring(0, 5) == 'hotel') ishotel = 1;
    if (args.resource.substring(0, 2) == 'rn') {
      is_room_number = 1;
      resource_id = args.resource.substring(2);
    } else resource_id = args.resource;
    if (ishotel == 1 || isgroup == 1) {
      args.allowed = false;
      return;
    }

    let roomId = 0,
      roomName = '',
      roomNumberId = 0,
      hotelId = 0;
    if (this.props.auth.authUser.rooms.length == 0 && is_room_number == 0) {
      roomId = resource_id;
      roomName = this.props.auth.authUser.roomtypes.find(({ ID }) => ID == resource_id).Name;
      if (this.props.auth.authUser.clouduser == 0)
        hotelId = this.props.auth.authUser.roomtypes.find(({ ID }) => ID == resource_id).hotelid;
    } else {
      if (this.props.auth.authUser.clouduser == 1)
        roomId = this.props.auth.authUser.rooms.find(({ ID }) => ID == resource_id).rtid;
      else {
        if (is_room_number == 1) roomId = this.props.auth.authUser.rooms.find(({ ID }) => ID == resource_id).rtId;
        else roomId = resource_id;
      }
      if (this.props.auth.authUser.clouduser == 0) {
        if (is_room_number == 1) hotelId = this.props.auth.authUser.rooms.find(({ ID }) => ID == resource_id).hotelid;
        else hotelId = this.props.auth.authUser.roomtypes.find(({ ID }) => ID == resource_id).hotelid;
      }
      if (this.props.auth.authUser.clouduser == 1)
        roomName = this.props.auth.authUser.rooms.find(({ ID }) => ID == resource_id).Name;
      else {
        if (is_room_number == 1) roomName = this.props.auth.authUser.rooms.find(({ ID }) => ID == resource_id).Name;
        else roomName = this.props.auth.authUser.roomtypes.find(({ ID }) => ID == resource_id).Name;
      }
      roomNumberId = resource_id;
    }

    if (this.props.auth.authUser.clouduser == 1) hotelId = this.state.hotelId;
    const { intl } = this.props;
    if (hotelId == 0 || roomId == 0) return;
    var rs1 =
      intl.formatMessage({ id: 'timeline.confirmCreate' }) +
      ' ' +
      intl.formatMessage({ id: 'timeline.confirmCreateFrom' }) +
      ' ' +
      getMyDate2(dateFrom, this.props.auth.authUser.language) +
      ' ' +
      intl.formatMessage({ id: 'timeline.confirmCreateTo' }) +
      ' ' +
      getMyDate2(dateTo, this.props.auth.authUser.language) +
      ' ' +
      intl.formatMessage({ id: 'room' }) +
      ' ' +
      roomName +
      '?';
    //var r = window.confirm(rs1);
    //if (r == true) {
    Swal.fire({
      title: intl.formatMessage({ id: 'pages.quickReservation' }),
      text: rs1,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: intl.formatMessage({ id: 'yes' }),
      cancelButtonText: intl.formatMessage({ id: 'no' }),
    }).then(result => {
      if (result.isConfirmed) {
        this.props.history.push(
          '/pages/quickreservation?hotelId=' +
            hotelId +
            '&roomId=' +
            roomId +
            '&roomNumberId=' +
            roomNumberId +
            '&dateFrom=' +
            dateFrom +
            '&dateTo=' +
            dateTo,
        );
      }
    });
  }
  eventMoving(args) {
    /*   if (this.props.auth.authUser.clouduser == 1) {
      args.allowed = false;
      return;
    }*/
    var isgroup = 0;
    var ishotel = 0;
    if (args.resource.substring(0, 5) == 'group') isgroup = 1;
    if (args.resource.substring(0, 5) == 'hotel') ishotel = 1;
    if (ishotel == 1 || isgroup == 1) args.allowed = false;
  }
  renderHeader(args) {
    if (args.header.level > 0) {
      var dayOfWeek = args.header.start.getDayOfWeek();
      if (dayOfWeek === 0 || dayOfWeek === 6) {
        args.header.backColor = '#f8f9fb';
        args.header.cssClass = 'weekend_header';
      }
    }
    if (args.header.start.getDayOfWeek() === 6 || args.header.start.getDayOfWeek() === 0) {
      args.header.backColor = '#f8f9fb';
    }
    if (args.header.start >= DayPilot.Date.today() && args.header.end <= DayPilot.Date.today().addDays(1)) {
      args.header.backColor = '#edd992';
      //#eff5fc
    }
  }
  eventMove(args) {
    /* if (this.props.auth.authUser.clouduser == 1) {
      return;
    }*/
    const { intl } = this.props;
    var rs1 = intl.formatMessage({ id: 'timeline.confirmMove' });
    var rs2 = intl.formatMessage({ id: 'moveRes' });
    const token = localStorage.getItem('token');
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;

    if (this.props.auth.authUser.clouduser == 1) {
      const senddata2 = {
        Action: 'validate_action',
        token: token,

        Data: {
          HotelId: this.state.hotelId,
          ReservationId: args.e.id(),
          Action: 'move_reservation',
          NewStart: getMyDate(args.newStart),
          NewEnd: getMyDate(args.newEnd),
          NewRoom: args.newResource,
          User: this.props.auth.authUser.name,
        },
      };
      axios.post(pmsUrl, senddata2).then(res => {
        if (res.data != null && res.data.Result != null) {
          console.log('xxx');
          console.log(res.data);
          //self.setState({ lastEvents: [], running2: false });
          if (res.data.Result == true) {
            console.log('tux');
            //var r2 = window.confirm(res.data.Message);
            Swal.fire({
              title: rs2,
              text: res.data.Message,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: intl.formatMessage({ id: 'yes' }),
              cancelButtonText: intl.formatMessage({ id: 'no' }),
            }).then(result => {
              if (result.isConfirmed) {
                console.log('tu');
                const senddata = {
                  Action: 'move_reservation',
                  token: token,
                  Data: {
                    HotelId: this.state.hotelId,
                    ReservationId: args.e.id(),
                    NewStart: getMyDate(args.newStart),
                    NewEnd: getMyDate(args.newEnd),
                    NewRoom: args.newResource,
                    User: this.props.auth.authUser.name,
                  },
                };
                console.log(senddata);

                //var pmsUrl = this.props.auth.authUser.pmsUrl;
                //var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
                this.setState({ running2: true });
                axios.post(pmsUrl, senddata).then(res => {
                  if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                    localStorage.setItem('token', res.data.newToken);
                  }
                  //this.scheduler.update();
                  this.doRefresh();
                  this.setState({ running2: false });
                });
              } else this.doRefresh();
            });
          } else {
            Swal.fire({
              title: intl.formatMessage({ id: 'error' }),
              text: res.data.Message,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: intl.formatMessage({ id: 'ok' }),
            }).then(result => {
              this.doRefresh();
            });
          }
        } else {
          this.doRefresh();
        }
      });
    } else {
      Swal.fire({
        title: rs2,
        text: rs1,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: intl.formatMessage({ id: 'yes' }),
        cancelButtonText: intl.formatMessage({ id: 'no' }),
      }).then(result => {
        if (result.isConfirmed) {
          //var r = window.confirm(rs1);
          //if (r == true) {
          const senddata = {
            Action: 'move_reservation',
            token: token,
            Data: {
              HotelId: this.state.hotelId,
              ResId: args.e.id(),
              NewStart: getMyDate(args.newStart),
              NewEnd: getMyDate(args.newEnd),
              NewRoom: args.newResource,
              User: this.props.auth.authUser.name,
            },
          };
          console.log(senddata);

          //var pmsUrl = this.props.auth.authUser.pmsUrl;
          //var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
          this.setState({ running2: true });
          axios.post(pmsUrl, senddata).then(res => {
            if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
              localStorage.setItem('token', res.data.newToken);
            }
            if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
            //this.scheduler.update();
            this.doRefresh();
            this.setState({ running2: false });
          });
        } else this.doRefresh();
      });
    } //else args.preventDefault();
  }

  eventResize(args) {
    /*  if (this.props.auth.authUser.clouduser == 1) {
      args.preventDefault();
      return;
    }*/
    const { intl } = this.props;
    var rs1 = intl.formatMessage({ id: 'timeline.confirmChange' });
    var rs2 = intl.formatMessage({ id: 'changeRes' });
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    if (pmsUrl == '') return;
    const token = localStorage.getItem('token');

    if (this.props.auth.authUser.clouduser == 1) {
      const senddata2 = {
        Action: 'validate_action',
        token: token,

        Data: {
          HotelId: this.state.hotelId,
          ReservationId: args.e.id(),
          Action: 'move_reservation',
          NewStart: getMyDate(args.newStart),
          NewEnd: getMyDate(args.newEnd),
          NewRoom: args.newResource,
          User: this.props.auth.authUser.name,
        },
      };
      axios.post(pmsUrl, senddata2).then(res => {
        if (res.data != null && res.data.Result != null) {
          console.log('xxx');
          console.log(res.data);
          //self.setState({ lastEvents: [], running2: false });
          if (res.data.Result == true) {
            console.log('tux');
            //var r2 = window.confirm(res.data.Message);
            //console.log(r2);
            //if (r2 == true) {
            Swal.fire({
              title: rs2,
              text: res.data.Message,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: intl.formatMessage({ id: 'yes' }),
              cancelButtonText: intl.formatMessage({ id: 'no' }),
            }).then(result => {
              if (result.isConfirmed) {
                console.log('tu');
                const senddata = {
                  Action: 'move_reservation',
                  token: token,
                  Data: {
                    HotelId: this.state.hotelId,
                    ReservationId: args.e.id(),
                    NewStart: getMyDate(args.newStart),
                    NewEnd: getMyDate(args.newEnd),
                    NewRoom: args.newResource,
                    User: this.props.auth.authUser.name,
                  },
                };
                console.log(senddata);

                //var pmsUrl = this.props.auth.authUser.pmsUrl;
                //var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
                this.setState({ running2: true });
                axios.post(pmsUrl, senddata).then(res => {
                  if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                    localStorage.setItem('token', res.data.newToken);
                  }
                  //this.scheduler.update();
                  this.doRefresh();
                  this.setState({ running2: false });
                });
              } else this.doRefresh();
            });
          } else {
            Swal.fire({
              title: intl.formatMessage({ id: 'error' }),
              text: res.data.Message,
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              confirmButtonText: intl.formatMessage({ id: 'ok' }),
            }).then(result => {
              this.doRefresh();
            });
          }
        } else {
          this.doRefresh();
        }
      });
    } else {
      Swal.fire({
        title: rs2,
        text: rs1,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: intl.formatMessage({ id: 'yes' }),
        cancelButtonText: intl.formatMessage({ id: 'no' }),
      }).then(result => {
        if (result.isConfirmed) {
          //}
          //var r = window.confirm(rs1);
          //if (r == true) {
          const senddata = {
            Action: 'move_reservation',
            token: token,
            Data: {
              HotelId: this.state.hotelId,
              ReservationId: args.e.id(),
              NewStart: getMyDate(args.newStart),
              NewEnd: getMyDate(args.newEnd),
              NewRoom: args.newResource,
              User: this.props.auth.authUser.name,
            },
          };

          //var pmsUrl = this.props.auth.authUser.pmsUrl;
          //var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';
          this.setState({ running2: true });
          axios.post(pmsUrl, senddata).then(res => {
            if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
              localStorage.setItem('token', res.data.newToken);
            }
            if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
            this.doRefresh();
            this.setState({ running2: false });
          });
        } else this.doRefresh();
      });
    }
  }

  runAction(event, action) {
    if (action == 'today') {
      //var curStart = this.state.dateStart;
      var newStart = moment().add(0, 'day');
      var newEnd = moment(newStart).add((parseInt(this.state.viewMode) + 1) * 7 + 3, 'day');
      this.setState({ lastStart: newStart, lastEnd: newEnd }, () => {
        this.doRefresh();
      });
    }
    if (action == 'prev') {
      var curStart = this.state.lastStart;
      var newStart = moment(curStart).add(-1 * (parseInt(this.state.viewMode) + 1) * 7, 'day');
      var newEnd = moment(newStart).add((parseInt(this.state.viewMode) + 1) * 7 + 3, 'day');
      this.setState({ lastStart: newStart, lastEnd: newEnd }, () => {
        this.doRefresh();
      });
      // this.createDays(newStart.format('YYYY-MM-DD'));
      //this.scheduler.scrollTo(this.scheduler.getDate(this.scheduler.getScrollX()).addMonths(-1));
    }
    if (action == 'next') {
      //this.scheduler.scrollTo(this.scheduler.getDate(this.scheduler.getScrollX()).addMonths(1));
      var curStart = this.state.lastStart;
      var newStart = moment(curStart).add((parseInt(this.state.viewMode) + 1) * 7, 'day');
      var newEnd = moment(newStart).add((parseInt(this.state.viewMode) + 1) * 7 + 3, 'day');
      this.setState({ lastStart: newStart, lastEnd: newEnd }, () => {
        this.doRefresh();
      });
    }
    if (action == 'today') {
      this.scheduler.scrollTo(DayPilot.Date.today());
    }
    if (action == 'settings') {
      this.setState({ settingsForm: true });
    }
    if (action == 'newreservation') {
      this.props.history.push('/pages/quickreservation');
    }
    if (action == 'eVError') {
      this.props.history.push('/pages/guests');
    }
    if (action == 'fError') {
      this.props.history.push('/pages/invoices');
    }
  }

  /*doRefresh()
  {

  }*/
  eventRowClick(args) {
    if (this.props.auth.authUser.clouduser == 0) {
      var rnId = args.row.as.id;
      if (String(rnId).substr(0, 5) == 'group') return;
      var sHId = -1;
      console.log(rnId);
      if (String(rnId).substr(0, 2) !== 'rn') {
        if (this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == rnId)[0].count != 1) return;
        sHId = this.props.auth.authUser.roomtypes.filter(({ ID }) => ID == rnId)[0].hotelid;
      } else {
        sHId = this.props.auth.authUser.rooms.filter(({ ID }) => 'rn' + ID == rnId)[0].hotelid;
      }
      var myStatus = args.row.as.data.status;
      if (myStatus == 'Z') myStatus = 'N';
      console.log(sHId + '-' + rnId);
      if (sHId != -1 && rnId != -1)
        this.setState({
          selectedRoomId: rnId,
          selectedHotelId: sHId,
          currentStatus: myStatus,
          setStatusVisible: true,
        });
    }
  }

  eventClick(args) {
    //    setOpenRes(true);
    if (this.props.auth.authUser.clouduser == 1) {
      this.setState({ selResTitle: args.e.id() });
      var x = this.state.lastEvents.find(({ id }) => id === args.e.id());
      if (x.hotelId == null || x.hotelId == undefined) x.hotelId = this.state.hotelId;

      this.setState({ selReservationId: args.e.id(), selReservationHotelId: x.hotelId });
    } else {
      var x = this.state.lastEvents.find(({ id }) => id === args.e.id());
      var title = '';
      var myhotelname = '';
      myhotelname = this.props.auth.authUser.hotels.find(({ id }) => id === x.hotelId).name;
      title += myhotelname + ': ' + x.bookingId + ': ' + x.text;

      this.setState({ selResTitle: title });
      this.setState({ selReservationId: x.bid, selReservationHotelId: x.hotelId });
    }
    this.setState({ resDetailsVisible: true });
    //alert(this.state.selReservationId);
  }

  handleCustomChange(event, owner) {
    if (owner == 'viewMode') {
      var cw = 20,
        cm = 0;
      if (event.target.value == 0) {
        cw = window.innerWidth / 20;
        cm = 0;
      }
      if (event.target.value == 1) {
        cw = window.innerWidth / 40;
        cm = 1;
      }
      if (event.target.value == 2) {
        cw = window.innerWidth / 60;
        cm = 2;
      }
      if (event.target.value == 3) {
        cw = window.innerWidth / 80;
        cm = 3;
      }
      if (event.target.value == 4) {
        cw = window.innerWidth / 95;
        cm = 4;
      }
      if (cw < 20) cw = 20;
      this.setState({ cellWidth: cw, viewMode: cm });

      localStorage.setItem('lastViewMode', event.target.value);

      return;
    }
    this.setState({ [owner]: event.target.value }, () => {
      if (owner == 'hotelId') {
        if (this.props.auth.authUser.cloudUser == 1) {
          var resources2 = this.props.auth.authUser.rooms;
          var resources = [];
          resources2
            .filter(({ hotelid }) => {
              return hotelid == event.target.value;
            })
            .forEach((e, i) => {
              e.id = e.ID;
              e.name = e.Name;
              resources.push(e);
            });
          console.log(resources);
          this.setState({ resources: resources }, () => {
            this.doRefresh();
          });
        } else {
          localStorage.setItem('lastHotelId', event.target.value);
          this.loadResources();
          this.doRefresh();
        }

        //        var curStart = this.state.dateStart;
        //this.createDays(curStart.format('YYYY-MM-DD'));
      }
    });
  }

  render() {
    const { ...config } = this.state;
    const { classes } = this.props;
    //const url = 'https://secure.webbookingpro.com/api/pms.php';
    var pmsUrl = this.props.auth.authUser.pmsUrl;
    var hotels = this.props.auth.authUser.hotels;
    var canAll = 1;
    if (this.props.auth.authUser.clouduser == 1 && hotels.length > 1) {
      var hotelCodes = [];
      hotels.map(function(item) {
        if (!hotelCodes.includes(item.hotelCode)) hotelCodes.push(item.hotelCode);
      });
      if (hotelCodes.length > 1) canAll = 0;
    }
    var userRole = this.props.auth.authUser.role;
    if (pmsUrl == '') return;
    return (
      <>
        <PageContainer>
          {this.state.checkData['f'] != null && this.state.checkData['f']['error'] == 1 && (
            <Alert
              onClick={e => this.runAction(e, 'fError')}
              severity={this.state.checkData['f']['warning'] == 1 ? 'error' : 'info'}>
              <IntlMessages id="errorFiscal" />
              {' ('}
              {this.state.checkData['f']['count']}
              {')'}
            </Alert>
          )}
          {this.state.checkData['eV'] != null && this.state.checkData['eV']['error'] == 1 && (
            <Alert
              onClick={e => this.runAction(e, 'eVError')}
              severity={this.state.checkData['eV']['warning'] == 1 ? 'error' : 'info'}>
              <IntlMessages id="errorEvisitor" />
              {' ('}
              {this.state.checkData['eV']['count']}
              {')'}
            </Alert>
          )}

          {((this.props.auth.authUser.clouduser == 1 && hotels.length > 1) || hotels.length > 1) && (
            <FormControl variant="filled" className={classes.hotelSelect}>
              <InputLabel id="hotel-label">Hotel</InputLabel>
              <Select
                labelId="hotel-label"
                id="hotelid"
                fullWidth
                className={classes.hotelSelect}
                name="hotelid"
                value={this.state.hotelId}
                onChange={event => this.handleCustomChange(event, 'hotelId')}>
                {hotels.map((t, idx) => (
                  <MenuItem value={t.id}>{t.name}</MenuItem>
                ))}
                {canAll == 1 && (
                  <MenuItem value={this.state.myhotels}>
                    <IntlMessages id="invoices.allProperties" />
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          )}
          <Grid container spacing={1}>
            <Grid item xs={10} sm={6} lg={6}>
              <Box className={classes.boxClass}>
                {this.props.auth.authUser.clouduser == 0 && [10].includes(userRole) && (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={e => this.runAction(e, 'newreservation')}>
                    <Add />
                  </Button>
                )}
                {this.props.auth.authUser.clouduser == 0 && (
                  <Button
                    style={{ marginLeft: '5px' }}
                    size="small"
                    variant="contained"
                    color="primary"
                    onClick={e => this.runAction(e, 'settings')}>
                    <SettingsIcon />
                  </Button>
                )}

                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={e => this.runAction(e, 'prev')}
                  style={{ padding: '5px' }}>
                  <NavigateBefore />
                </IconButton>

                {this.scheduler != null && (
                  <KeyboardDatePicker
                    margin="small"
                    id="date-picker-dialog"
                    format={myFormatDate2(this.props.auth.authUser.dateTimeMode)}
                    autoOk="true"
                    style={{ width: 150 }}
                    value={this.state.lastStart}
                    onChange={date => {
                      try {
                        var mydate = getMyDate(date);
                        var mydate2 = moment(mydate)
                          .add((parseInt(this.state.viewMode) + 1) * 7 + 3, 'days')
                          .format('YYYY-MM-DD');
                      } catch (e) {
                        return;
                      }
                      if (mydate != 'NaN-NaN-NaN') {
                        this.setState({ lastStart: mydate, lastEnd: mydate2 }, () => {
                          this.doRefresh();
                        });

                        this.scheduler.scrollTo(mydate);
                      }
                    }}
                    KeyboardButtonProps={{
                      'aria-label': 'change date',
                    }}
                  />
                )}
                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={e => this.runAction(e, 'next')}
                  style={{ padding: '5px' }}>
                  <NavigateNext />
                </IconButton>
                <IconButton
                  variant="contained"
                  color="primary"
                  onClick={e => this.runAction(e, 'today')}
                  style={{ padding: '5px' }}>
                  <MyLocation />
                </IconButton>
                {this.props.auth.authUser.clouduser == 1 && (
                  <TextField
                    id="viewMode"
                    name="viewMode"
                    select
                    defaultValue=""
                    value={this.state.viewMode}
                    className={classes.viewModeSelect}
                    onChange={event => this.handleCustomChange(event, 'viewMode')}>
                    <MenuItem value="0">1x</MenuItem>
                    <MenuItem value="1">2x</MenuItem>
                    <MenuItem value="2">3x</MenuItem>
                    <MenuItem value="3">4x</MenuItem>
                    <MenuItem value="4">5x</MenuItem>
                  </TextField>
                )}
              </Box>
            </Grid>
            <Grid item xs={2} sm={6} lg={6}>
              <Box className={classes.boxClass2}></Box>
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              {this.props.auth.authUser.clouduser == 1 && (
                <Box className={classes.boxClass}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={e => this.runAction(e, 'newreservation')}
                    startIcon={<Add />}>
                    <IntlMessages id="pages.quickReservation" />
                  </Button>
                </Box>
              )}
            </Grid>
          </Grid>
          <GridContainer>
            <Grid item xs={12}>
              {this.state.errorConnection && (
                <Alert severity="error">
                  <IntlMessages id={'error.connection'} />
                </Alert>
              )}

              <DayPilotScheduler
                {...config}
                onBeforeRowHeaderRender={args => {
                  //if row
                  //if (args.row.as.data.status == undefined) args.row.cssClass = 'statusClean';
                  args.row.cssClass = '';
                  //console.log(args.row);
                  if (args.row.as.data.status == 'C') args.row.cssClass = 'statusClean';
                  if (args.row.as.data.status == 'Z') args.row.cssClass = 'statusInUse';
                  if (args.row.as.data.status == 'N') args.row.cssClass = 'statusDirty';

                  args.row.columns[0].areas = [
                    {
                      right: 3,
                      top: 3,
                      width: 16,
                      height: 16,
                      cssClass: 'area-menu',
                      action: 'ContextMenu',
                      visibility: 'Hover',
                    },
                  ];
                  /*args.row.columns[1].areas = [];
                    args.row.columns[1].areas.push({
                      right: 2,
                      top: 2,
                      bottom: 2,
                      width: 3,
                      backColor: 'red'
                    });*/
                }}
                onBeforeCellRender={args => {
                  if (args.cell.start.getDayOfWeek() === 6 || args.cell.start.getDayOfWeek() === 0) {
                    args.cell.backColor = '#f8f9fb';
                  }
                  if (args.cell.start >= DayPilot.Date.today() && args.cell.end <= DayPilot.Date.today().addDays(1)) {
                    args.cell.backColor = '#edd992';
                  }
                }}
                onBeforeEventRender={args => {
                  args.data.barHidden = true;
                  var x = args.data.resource;
                  if (typeof x == 'string')
                    if (x.substring(0, 5) == 'group') args.data.cssClass = 'scheduler_default_event2';
                  //console.log();
                  //if (args.e && !this.canMove(args))

                  //args.data.bubbleHtml = 'Additional information for: ' + args.e.text;
                }}
                onRowClick={args => {
                  this.eventRowClick(args);
                }}
                onEventClick={args => {
                  if (!this.canMove(args)) args.allowed = false;
                  else {
                    this.eventClick(args);
                  }
                }}
                onEventMoving={args => {
                  if (!this.canMove(args)) args.allowed = false;
                  else {
                    if ([10].includes(userRole)) this.eventMoving(args);
                    else args.allowed = false;
                  }
                }}
                onEventResize={args => {
                  if ([10].includes(userRole)) this.eventResize(args);
                }}
                onEventMove={args => {
                  if (!this.canMove(args)) args.allowed = false;
                  else {
                    if ([10].includes(userRole)) this.eventMove(args);
                  }
                }}
                onEventResizing={args => {
                  if (!this.canMove(args)) args.allowed = false;
                  else {
                    if ([10].includes(userRole)) args.allowed = true;
                    else args.allowed = false;
                  }
                }}
                onTimeRangeSelected={args => {
                  if ([10].includes(userRole)) this.eventCreate(args);
                }}
                onBeforeTimeHeaderRender={args => {
                  this.renderHeader(args);
                }}
                onScroll={args => {
                  args.async = true;

                  var start = args.viewport.start;
                  var end = args.viewport.end;

                  if (start != this.state.lastStart || end != this.state.lastEnd) {
                    this.setState({ running2: true });
                    const token = localStorage.getItem('token');
                    var senddata = {};
                    if (this.props.auth.authUser.clouduser == 0)
                      senddata = {
                        Action: 'get_reservations',
                        token: token,
                        Version: 1,
                        Data: {
                          HotelId: this.state.myhotels,
                          From: start.toString().substring(0, 10),
                          To: end.toString().substring(0, 10),
                        },
                      };
                    else
                      senddata = {
                        Action: 'get_reservations',
                        token: token,
                        Version: 1,
                        Data: {
                          HotelId: this.state.myhotels,
                          PeriodStart: start.toString().substring(0, 10),
                          PeriodEnd: end.toString().substring(0, 10),
                          SearchModel: 5,
                        },
                      };

                    console.log('url2: ' + pmsUrl);
                    var self = this;
                    axios.post(pmsUrl, senddata).then(res => {
                      if (res.data != null && res.data.newToken != null && res.data.newToken != '') {
                        localStorage.setItem('token', res.data.newToken);
                      }
                      if (this.props.auth.authUser.clouduser == 0 && res.data.success == 'false') window.location.reload();
                      this.setState({ lastStart: start });
                      this.setState({ lastEnd: end });
                      const data = res.data;
                      //            this.setState({ persons });
                      var newevents = data.Data;
                      if (data.Data != null && data.Data.Error != undefined) {
                        this.setState({ errorConnection: true, running2: false });
                      } else if (data.Data == null) {
                        this.setState({ errorConnection: true, running2: false });
                      } else {
                        this.setState({ errorConnection: false });

                        console.log(res);
                        console.log(data);
                        console.log(newevents);
                        if (Array.isArray(newevents))
                          newevents.forEach(function(item, index) {
                            item['resource'] = item['RoomId'];
                            item['start'] = item['Checkin'] + 'T12:00:00';
                            item['end'] = item['Checkout'] + 'T12:00:00';
                            if (self.props.auth.authUser.clouduser == 1) item['id'] = item['ReservationId'];
                            else item['id'] = item['ReservationRoomId'];
                            item['bid'] = item['ReservationId'];
                            item['bookingId'] = item['BookingId'];
                            item['text'] = item['Text'];
                            item['source'] = item['source'];
                            item['backColor'] = item['Color'];
                            //if (self.props.auth.authUser.clouduser == 0) item['bubbleHtml'] = item['bubbleHtml'];
                            //item['bubbleHtml'] = 'test';
                            // if (item['TextColor']!=null) item['textColor'] = '#ffffff';
                          });
                        this.setState({ lastEvents: newevents });

                        args.events = newevents;
                        this.setState({ running2: false });
                        try {
                          args.loaded();
                        } catch (e) {}
                      }
                    });
                  } else {
                    args.events = this.state.lastEvents;

                    try {
                      args.loaded();
                    } catch (e) {}
                  }
                }}
                ref={component => {
                  this.scheduler = component && component.control;
                }}
              />
            </Grid>
          </GridContainer>
        </PageContainer>
        {this.state.running2 && <LinearProgress />}

        <SetRoomStatus
          open={this.state.setStatusVisible}
          anchorEl={this.state.myanchorEl}
          currentStatus={this.state.currentStatus}
          selectedRoomid={this.state.selectedRoomId}
          selectedHotelId={this.state.selectedHotelId}
          /*moveFolio={p => {
              this.eventClick('moveFolioItem2', p);
            }}*/
          loadResources={this.loadResources}
          setState={p => {
            this.setState(p);
          }}
        />
        <SettingsForm2
          open={this.state.settingsForm}
          setState={p => {
            this.setState(p, () => {
              this.doRefresh();
            });
          }}
          refresh={p => {
            this.doRefresh();
          }}
        />
        <ResDetais
          resId={this.state.selReservationId}
          resTitle={this.state.selResTitle}
          hotelId={this.state.selReservationHotelId}
          open={this.state.resDetailsVisible}
          doLoadResources={this.loadResources}
          doRefresh={this.doRefresh}
          setState={p => {
            this.setState(p, () => {
              //this.doRefresh();
            });
          }}
        />
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    auth: state.auth,
  };
};

TimeLine.contextType = AppContext;
export default withStyles(useStyles)(connect(mapStateToProps)(injectIntl(TimeLine)));
